import classNames from 'classnames';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {defineMessages, FormattedMessage, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import bowser from 'bowser';
import React from 'react';

import VM from 'scratch-vm';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import CommunityButton from './community-button.jsx';
import ShareButton from './share-button.jsx';
import {ComingSoonTooltip} from '../coming-soon/coming-soon.jsx';
import Divider from '../divider/divider.jsx';
// import LanguageSelector from '../../containers/language-selector.jsx';
import SaveStatus from './save-status.jsx';
import ProjectWatcher from '../../containers/project-watcher.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import {MenuItem, MenuSection} from '../menu/menu.jsx';
import ProjectTitleInput from './project-title-input.jsx';
import AuthorInfo from './author-info.jsx';
import AccountNav from '../../containers/account-nav.jsx';
import LoginDropdown from './login-dropdown.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import SB3SaveProject from '../../containers/sb3-save-project.jsx';
import DeletionRestorer from '../../containers/deletion-restorer.jsx';
import TurboMode from '../../containers/turbo-mode.jsx';
import MenuBarHOC from '../../containers/menu-bar-hoc.jsx';


// import ComProjectSelection from './comProjectSelection.jsx';
import ComProjectSelection from '../../containers/comProjectSelection.jsx';

import {openTipsLibrary} from '../../reducers/modals';
import {setPlayer} from '../../reducers/mode';
import {
    isTimeTravel220022BC,
    isTimeTravel1920,
    isTimeTravel1990,
    isTimeTravel2020,
    isTimeTravelNow,
    setTimeTravel
} from '../../reducers/time-travel';
import {
    autoUpdateProject,
    getIsUpdating,
    getIsShowingProject,
    manualUpdateProject,
    requestNewProject,
    remixProject,
    saveProjectAsCopy
} from '../../reducers/project-state';
import {
    openAboutMenu,
    closeAboutMenu,
    aboutMenuOpen,
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    // openLanguageMenu,
    // closeLanguageMenu,
    // languageMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    openModeMenu,
    closeModeMenu,
    modeMenuOpen,
    openBackPackMenu,
    closeBackPackMenu,
    backPackMenuOpen,

} from '../../reducers/menus';

import collectMetadata from '../../lib/collect-metadata';

import styles from './menu-bar.css';

import helpIcon from '../../lib/assets/icon--tutorials.svg';
import mystuffIcon from './icon--mystuff.png';
import profileIcon from './icon--profile.png';
import remixIcon from './icon--remix.svg';
import dropdownCaret from './dropdown-caret.svg';
// import languageIcon from '../language-selector/language-icon.svg';
import aboutIcon from './icon--about.svg';

import scratchLogo from './scratch-logo.svg';
import stemAcademyLogo from './stem-academy-logo-white.png';
import ninetiesLogo from './nineties_logo.svg';
import catLogo from './cat_logo.svg';
import prehistoricLogo from './prehistoric-logo.svg';
import oldtimeyLogo from './oldtimey-logo.svg';

import sharedMessages from '../../lib/shared-messages';

const ariaMessages = defineMessages({
    // language: {
    //     id: 'gui.menuBar.LanguageSelector',
    //     defaultMessage: 'language selector',
    //     description: 'accessibility text for the language selection menu'
    // },
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Tutorials',
        description: 'accessibility text for the tutorials button'
    }
});

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return (
        <ComingSoonTooltip
            className={classNames(styles.comingSoon, className)}
            place={place}
            tooltipClassName={styles.comingSoonTooltip}
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};


MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const MenuItemTooltip = ({id, isRtl, children, className}) => (
    <ComingSoonTooltip
        className={classNames(styles.comingSoon, className)}
        isRtl={isRtl}
        place={isRtl ? 'left' : 'right'}
        tooltipClassName={styles.comingSoonTooltip}
        tooltipId={id}
    >
        {children}
    </ComingSoonTooltip>
);

MenuItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool
};

const AboutButton = props => (
    <Button
        className={classNames(styles.menuBarItem, styles.hoverable)}
        iconClassName={styles.aboutIcon}
        iconSrc={aboutIcon}
        onClick={props.onClick}
    />
);

AboutButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

class MenuBar extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClickNew',
            'handleClickRemix',
            'handleClickSave',
            'handleClickSaveAsCopy',
            // 'handleClickSeeCommunity',
            'handleClickShare',
            'handleSetMode',
            'handleKeyPress',
            // 'handleLanguageMouseUp',
            'handleRestoreOption',
            'getSaveToComputerHandler',
            'restoreOptionMessage'
        ]);
    }
    componentDidMount () {
        console.log( ``)
        document.addEventListener('keydown', this.handleKeyPress);
    }
    componentWillUnmount () {
        document.removeEventListener('keydown', this.handleKeyPress);
    }
    handleClickNew () {
        // if the project is dirty, and user owns the project, we will autosave.
        // but if they are not logged in and can't save, user should consider
        // downloading or logging in first.
        // Note that if user is logged in and editing someone else's project,
        // they'll lose their work.
        const readyToReplaceProject = this.props.confirmReadyToReplaceProject(
            this.props.intl.formatMessage(sharedMessages.replaceProjectWarning)
        );
        this.props.onRequestCloseFile();
        if (readyToReplaceProject) {
            this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
        }
        this.props.onRequestCloseFile();
        window.location = "index.php";
    }
    handleClickRemix () {
        this.props.onClickRemix();
        this.props.onRequestCloseFile();
    }
    handleClickSave () {
        this.props.onClickSave();
        this.props.onRequestCloseFile();
    }
    handleClickSaveAsCopy () {
        this.props.onClickSaveAsCopy();
        this.props.onRequestCloseFile();
    }
    // handleClickSeeCommunity (waitForUpdate) {
    //     if (this.props.shouldSaveBeforeTransition()) {
    //         this.props.autoUpdateProject(); // save before transitioning to project page
    //         waitForUpdate(true); // queue the transition to project page
    //     } else {
    //         waitForUpdate(false); // immediately transition to project page
    //     }
    // }
    handleClickShare (waitForUpdate) {
        if (!this.props.isShared) {
            if (this.props.canShare) { // save before transitioning to project page
                this.props.onShare();
            }
            if (this.props.canSave) { // save before transitioning to project page
                this.props.autoUpdateProject();
                waitForUpdate(true); // queue the transition to project page
            } else {
                waitForUpdate(false); // immediately transition to project page
            }
        }
    }
    handleSetMode (mode) {
        return () => {
            // Turn on/off filters for modes.
            if (mode === '1920') {
                document.documentElement.style.filter = 'brightness(.9)contrast(.8)sepia(1.0)';
                document.documentElement.style.height = '100%';
            } else if (mode === '1990') {
                document.documentElement.style.filter = 'hue-rotate(40deg)';
                document.documentElement.style.height = '100%';
            } else {
                document.documentElement.style.filter = '';
                document.documentElement.style.height = '';
            }

            // Change logo for modes
            if (mode === '1990') {
                document.getElementById('logo_img').src = ninetiesLogo;
            } else if (mode === '2020') {
                document.getElementById('logo_img').src = catLogo;
            } else if (mode === '1920') {
                document.getElementById('logo_img').src = oldtimeyLogo;
            } else if (mode === '220022BC') {
                document.getElementById('logo_img').src = prehistoricLogo;
            } else {
                document.getElementById('logo_img').src = this.props.logo;
            }

            this.props.onSetTimeTravelMode(mode);
        };
    }
    handleRestoreOption (restoreFun) {
        return () => {
            restoreFun();
            this.props.onRequestCloseEdit();
        };
    }
    handleKeyPress (event) {
        const modifier = bowser.mac ? event.metaKey : event.ctrlKey;
        if (modifier && event.key === 's') {
            this.props.onClickSave();
            event.preventDefault();
        }
    }
    getSaveToComputerHandler (downloadProjectCallback) {
        return () => {
            this.props.onRequestCloseFile();
            downloadProjectCallback();
            if (this.props.onProjectTelemetryEvent) {
                const metadata = collectMetadata(this.props.vm, this.props.projectTitle, this.props.locale);
                this.props.onProjectTelemetryEvent('projectDidSave', metadata);
            }
        };
    }
    // handleLanguageMouseUp (e) {
    //     if (!this.props.languageMenuOpen) {
    //         this.props.onClickLanguage(e);
    //     }
    // }
    restoreOptionMessage (deletedItem) {
        switch (deletedItem) {
        case 'Sprite':
            return (<FormattedMessage
                defaultMessage="Restore Sprite"
                description="Menu bar item for restoring the last deleted sprite."
                id="gui.menuBar.restoreSprite"
            />);
        case 'Sound':
            return (<FormattedMessage
                defaultMessage="Restore Sound"
                description="Menu bar item for restoring the last deleted sound."
                id="gui.menuBar.restoreSound"
            />);
        case 'Costume':
            return (<FormattedMessage
                defaultMessage="Restore Costume"
                description="Menu bar item for restoring the last deleted costume."
                id="gui.menuBar.restoreCostume"
            />);
        default: {
            return (<FormattedMessage
                defaultMessage="Restore"
                description="Menu bar item for restoring the last deleted item in its disabled state." /* eslint-disable-line max-len */
                id="gui.menuBar.restore"
            />);
        }
        }
    }
    buildAboutMenu (onClickAbout) {
        if (!onClickAbout) {
            // hide the button
            return null;
        }
        if (typeof onClickAbout === 'function') {
            // make a button which calls a function
            return <AboutButton onClick={onClickAbout} />;
        }
        // assume it's an array of objects
        // each item must have a 'title' FormattedMessage and a 'handleClick' function
        // generate a menu with items for each object in the array
        return (
            <div
                className={classNames(styles.menuBarItem, styles.hoverable, {
                    [styles.active]: this.props.aboutMenuOpen
                })}
                onMouseUp={this.props.onRequestOpenAbout}
            >
                <img
                    className={styles.aboutIcon}
                    src={aboutIcon}
                />
                <MenuBarMenu
                    className={classNames(styles.menuBarMenu)}
                    open={this.props.aboutMenuOpen}
                    place={this.props.isRtl ? 'right' : 'left'}
                    onRequestClose={this.props.onRequestCloseAbout}
                >
                    {
                        onClickAbout.map(itemProps => (
                            <MenuItem
                                key={itemProps.title}
                                isRtl={this.props.isRtl}
                                onClick={this.wrapAboutMenuCallback(itemProps.onClick)}
                            >
                                {itemProps.title}
                            </MenuItem>
                        ))
                    }
                </MenuBarMenu>
            </div>
        );
    }
    wrapAboutMenuCallback (callback) {
        return () => {
            callback();
            this.props.onRequestCloseAbout();
        };
    }
    render () {
        const saveNowMessage = (
            <FormattedMessage
                defaultMessage="Save now"
                description="Menu bar item for saving now"
                id="gui.menuBar.saveNow"
            />
        );
        const createCopyMessage = (
            <FormattedMessage
                defaultMessage="Save as a copy"
                description="Menu bar item for saving as a copy"
                id="gui.menuBar.saveAsCopy"
            />
        );
        const remixMessage = (
            <FormattedMessage
                defaultMessage="Remix"
                description="Menu bar item for remixing"
                id="gui.menuBar.remix"
            />
        );
        const newProjectMessage = (
            <FormattedMessage
                defaultMessage="New"
                description="Menu bar item for creating a new project"
                id="gui.menuBar.new"
            />
        );
        const remixButton = (
            <Button
                className={classNames(
                    styles.menuBarButton,
                    styles.remixButton
                )}
                iconClassName={styles.remixButtonIcon}
                iconSrc={remixIcon}
                onClick={this.handleClickRemix}
            >
                {remixMessage}
            </Button>
        );
        // Show the About button only if we have a handler for it (like in the desktop app)
        const aboutButton = this.buildAboutMenu(this.props.onClickAbout);
        return (
            <>
                <ComProjectSelection ref={ (ref) =>{ this.ComProjectSelection = ref } } />
                <Box
                    className={classNames(
                        this.props.className,
                        styles.menuBar
                    )}
                >
                    <img
                        id="stem_academy_img"
                        alt="Stem Academy"
                        className={classNames(styles.stemAcademyLogo)}
                        draggable={false}
                        src={this.props.stemAcademyLogo} 
                        onClick={() => {} }
                    />
                    <div className={styles.mainMenu}>
                        <div className={styles.fileGroup}>
                            <div className={classNames(styles.menuBarItem)}>
                                <img
                                    id="logo_img"
                                    alt="Scratch"
                                    className={classNames(styles.scratchLogo)}
                                    draggable={false}
                                    src={this.props.logo}
                                    onClick={()=>{ }}
                                />
                            </div>
                            {/* {(this.props.canChangeLanguage) && (<div
                                className={classNames(styles.menuBarItem, styles.hoverable, styles.languageMenu)}
                            >
                                <div>
                                    <img
                                        className={styles.languageIcon}
                                        src={languageIcon}
                                    />
                                    <img
                                        className={styles.languageCaret}
                                        src={dropdownCaret}
                                    />
                                </div>
                                <LanguageSelector label={this.props.intl.formatMessage(ariaMessages.language)} />
                            </div>)} */}
                            {(this.props.canManageFiles) && (
                                <div
                                    className={classNames(styles.menuBarItem, styles.hoverable, {
                                        [styles.active]: this.props.fileMenuOpen
                                    })}
                                    onMouseUp={this.props.onClickFile}
                                >
                                    <FormattedMessage
                                        defaultMessage="File"
                                        description="Text for file dropdown menu"
                                        id="gui.menuBar.file"
                                    />
                                    <MenuBarMenu
                                        className={classNames(styles.menuBarMenu)}
                                        open={this.props.fileMenuOpen}
                                        place={this.props.isRtl ? 'left' : 'right'}
                                        onRequestClose={this.props.onRequestCloseFile}
                                    >
                                        <MenuSection>
                                            <MenuItem
                                                isRtl={this.props.isRtl}
                                                onClick={this.handleClickNew}
                                            >
                                                {newProjectMessage}
                                            </MenuItem>
                                        </MenuSection>
                                        {/* {(this.props.canSave || this.props.canCreateCopy || this.props.canRemix) && (
                                            <MenuSection>
                                                {this.props.canSave && (
                                                    <MenuItem onClick={this.handleClickSave}>
                                                        {saveNowMessage}
                                                    </MenuItem>
                                                )}
                                                {this.props.canCreateCopy && (
                                                    <MenuItem onClick={this.handleClickSaveAsCopy}>
                                                        {createCopyMessage}
                                                    </MenuItem>
                                                )}
                                                {this.props.canRemix && (
                                                    <MenuItem onClick={this.handleClickRemix}>
                                                        {remixMessage}
                                                    </MenuItem>
                                                )}
                                            </MenuSection>
                                        )} */}
                                        
                                        
                                        {/* <MenuSection>
                                            <MenuItem
                                                onClick={this.props.onStartSelectingBackPackFile}
                                            >
                                                {this.props.intl.formatMessage(sharedMessages.loadBackpackFromFile )}
                                            </MenuItem>
                                            <MenuItem
                                                onClick={this.props.onStartSaveBackPackFile}
                                                onClic2={()=>{
                                                    const LOCALSTORAGE_KEY = '[stemground] backpack'
                                                    console.log( sessionStorage.getItem(LOCALSTORAGE_KEY) || '[]' );
                                                }}
                                            >
                                                {this.props.intl.formatMessage(sharedMessages.saveBackpackToFile )}
                                            </MenuItem>
                                        </MenuSection> */}
                                        <MenuSection>
                                            {/* <MenuItem
                                                onClick={()=>{
                                                    // console.log( "pressed", this.ComProjectSelection  );
                                                    // this.ComProjectSelection.setState( { isShow: true })
                                                    this.ComProjectSelection.showHide( true, "project_list" );
                                                }}
                                            >
                                                {this.props.intl.formatMessage(sharedMessages.loadFromServerTitle )}
                                            </MenuItem> */}
                                            <MenuItem
                                                onClick={this.props.onStartSelectingFileUpload}
                                            >
                                                {this.props.intl.formatMessage(sharedMessages.loadFromComputerTitle)}
                                            </MenuItem>

                                            
                                            <SB3Downloader>{(className, downloadProjectCallback) => (
                                                <MenuItem
                                                    className={className}
                                                    onClick={this.getSaveToComputerHandler(downloadProjectCallback)}
                                                >
                                                    <FormattedMessage
                                                        defaultMessage="Save to your computer"
                                                        description="Menu bar item for downloading a project to your computer" // eslint-disable-line max-len
                                                        id="gui.menuBar.downloadToComputer"
                                                    />
                                                </MenuItem>
                                            )}</SB3Downloader>
                                        </MenuSection>
                                    </MenuBarMenu>
                                </div>
                            )}
                            <div
                                className={classNames(styles.menuBarItem, styles.hoverable, {
                                    [styles.active]: this.props.editMenuOpen
                                })}
                                onMouseUp={this.props.onClickEdit}
                            >
                                <div className={classNames(styles.editMenu)}>
                                    <FormattedMessage
                                        defaultMessage="Edit"
                                        description="Text for edit dropdown menu"
                                        id="gui.menuBar.edit"
                                    />
                                </div>
                                <MenuBarMenu
                                    className={classNames(styles.menuBarMenu)}
                                    open={this.props.editMenuOpen}
                                    place={this.props.isRtl ? 'left' : 'right'}
                                    onRequestClose={this.props.onRequestCloseEdit}
                                >
                                    <DeletionRestorer>{(handleRestore, {restorable, deletedItem}) => (
                                        <MenuItem
                                            className={classNames({[styles.disabled]: !restorable})}
                                            onClick={this.handleRestoreOption(handleRestore)}
                                        >
                                            {this.restoreOptionMessage(deletedItem)}
                                        </MenuItem>
                                    )}</DeletionRestorer>
                                    <MenuSection>
                                        <TurboMode>{(toggleTurboMode, {turboMode}) => (
                                            <MenuItem onClick={toggleTurboMode}>
                                                {turboMode ? (
                                                    <FormattedMessage
                                                        defaultMessage="Turn off Turbo Mode"
                                                        description="Menu bar item for turning off turbo mode"
                                                        id="gui.menuBar.turboModeOff"
                                                    />
                                                ) : (
                                                    <FormattedMessage
                                                        defaultMessage="Turn on Turbo Mode"
                                                        description="Menu bar item for turning on turbo mode"
                                                        id="gui.menuBar.turboModeOn"
                                                    />
                                                )}
                                            </MenuItem>
                                        )}</TurboMode>
                                    </MenuSection>
                                </MenuBarMenu>

                            </div>
                        </div>
                        {/* <Divider className={classNames(styles.divider)} />
                        <div
                            aria-label={this.props.intl.formatMessage(ariaMessages.tutorials)}
                            className={classNames(styles.menuBarItem, styles.hoverable)}
                            onClick={this.props.onOpenTipLibrary}
                        >
                            <img
                                className={styles.helpIcon}
                                src={helpIcon}
                            />
                            <FormattedMessage {...ariaMessages.tutorials} />
                        </div> */}
                        
                    
                        
                        <Divider className={classNames(styles.divider)} />
                        {this.props.canEditTitle ? (
                            <div className={classNames(styles.menuBarItem, styles.growable)}>
                                <MenuBarItemTooltip
                                    enable
                                    id="title-field"
                                >
                                    <ProjectTitleInput
                                        className={classNames(styles.titleFieldGrowable)}
                                    />
                                </MenuBarItemTooltip>
                            </div>
                        ) : ((this.props.authorUsername && this.props.authorUsername !== this.props.username) ? (
                            <AuthorInfo
                                className={styles.authorInfo}
                                imageUrl={this.props.authorThumbnailUrl}
                                projectTitle={this.props.projectTitle}
                                userId={this.props.authorId}
                                username={this.props.authorUsername}
                            />
                        ) : null)}
                        {/* <div className={classNames(styles.menuBarItem)}>
                            {this.props.canShare ? (
                                (this.props.isShowingProject || this.props.isUpdating) && (
                                    <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                        {
                                            waitForUpdate => (
                                                <ShareButton
                                                    className={styles.menuBarButton}
                                                    isShared={this.props.isShared}
                                                    onClick={() => {
                                                        this.handleClickShare(waitForUpdate);
                                                    }}
                                                />
                                            )
                                        }
                                    </ProjectWatcher>
                                )
                            ) : (
                                this.props.showComingSoon ? (
                                    <MenuBarItemTooltip id="share-button">
                                        <ShareButton className={styles.menuBarButton} />
                                    </MenuBarItemTooltip>
                                ) : []
                            )}
                            {this.props.canRemix ? remixButton : []}
                        </div> */}
                        {/* <div className={classNames(styles.menuBarItem, styles.communityButtonWrapper)}>
                            {this.props.enableCommunity ? (
                                (this.props.isShowingProject || this.props.isUpdating) && (
                                    <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                        {
                                            waitForUpdate => (
                                                <CommunityButton
                                                    className={styles.menuBarButton}
                                                    onClick={() => {
                                                        this.handleClickSeeCommunity(waitForUpdate);
                                                    }}
                                                />
                                            )
                                        }
                                    </ProjectWatcher>
                                )
                            ) : (this.props.showComingSoon ? (
                                <MenuBarItemTooltip id="community-button">
                                    <CommunityButton className={styles.menuBarButton} />
                                </MenuBarItemTooltip>
                            ) : [])}
                        </div> */}
                        {/* <div className={classNames(styles.menuBarItem)}>
                            <img
                                id="stem_academy_img"
                                alt="Stem Academy"
                                className={classNames(styles.stemAcademyLogo, {
                                    [styles.clickable]: typeof this.props.onClickLogo !== 'undefined'
                                })}
                                draggable={false}
                                src={this.props.stemAcademyLogo} 
                                onClick={this.props.onClickLogo}
                            />
                        </div> */}
                    </div>

                    {/* show the proper UI in the account menu, given whether the user is
                    logged in, and whether a session is available to log in with */}
                    <div className={styles.accountInfoGroup}>
                    
                        
                                <React.Fragment>
                                    {/* <a href="/mystuff/">
                                        <div
                                            className={classNames(
                                                styles.menuBarItem,
                                                styles.hoverable,
                                                styles.mystuffButton
                                            )}
                                        >
                                            <img
                                                className={styles.mystuffIcon}
                                                src={mystuffIcon}
                                            />
                                        </div>
                                    </a> */}
                                    <div
                                        className={classNames(styles.menuBarItem, styles.hoverable, {
                                            [styles.active]: this.props.backPackMenuOpen
                                        })}
                                        onMouseUp={this.props.onClickBackPack}
                                    >
                                        <div
                                            className={classNames(
                                                styles.mystuffButton
                                            )}
                                        >
                                            <img
                                                className={styles.mystuffIcon}
                                                src={mystuffIcon}
                                            />
                                        </div>
                                        <MenuBarMenu
                                            className={classNames(styles.menuBarMenu)}
                                            open={this.props.backPackMenuOpen}
                                            place='left'
                                            onRequestClose={this.props.onRequestCloseBackPack}
                                        >
                                            <MenuSection>
                                                <MenuItem
                                                    onClick={this.props.onStartSelectingBackPackFile}
                                                >
                                                    {this.props.intl.formatMessage(sharedMessages.loadBackpackFromFile )}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={this.props.onStartSaveBackPackFile}
                                                    onClic2={()=>{
                                                        const LOCALSTORAGE_KEY = '[stemground] backpack'
                                                        console.log( sessionStorage.getItem(LOCALSTORAGE_KEY) || '[]' );
                                                    }}
                                                >
                                                    {this.props.intl.formatMessage(sharedMessages.saveBackpackToFile )}
                                                </MenuItem>
                                            </MenuSection>
                                        </MenuBarMenu>

                                    </div>
                                    <AccountNav
                                        className={classNames(
                                            styles.menuBarItem,
                                            styles.hoverable,
                                            {[styles.active]: this.props.accountMenuOpen}
                                        )}
                                        isOpen={this.props.accountMenuOpen}
                                        isRtl={this.props.isRtl}
                                        menuBarMenuClassName={classNames(styles.menuBarMenu)}
                                        onClick={this.props.onClickAccount}
                                        onClose={this.props.onRequestCloseAccount}
                                        onLogOut={this.props.onLogOut}
                                        onAccountInfo={ () => { 
                                            console.log( "test account info" );
                                        }}
                                        onTutorialList={()=>{
                                            if ( _onTutorialList ) {
                                                _onTutorialList();
                                            }
                                            // this.ComProjectSelection.showHide( true, "tutorial_list" );
                                        }}
                                    />
                                </React.Fragment>
                            
                        {/* ) : (
                            <React.Fragment>
                                {this.props.showComingSoon ? (
                                    <React.Fragment>
                                        <MenuBarItemTooltip id="mystuff">
                                            <div
                                                className={classNames(
                                                    styles.menuBarItem,
                                                    styles.hoverable,
                                                    styles.mystuffButton
                                                )}
                                            >
                                                <img
                                                    className={styles.mystuffIcon}
                                                    src={mystuffIcon}
                                                />
                                            </div>
                                        </MenuBarItemTooltip>
                                        <MenuBarItemTooltip
                                            id="account-nav"
                                            place={this.props.isRtl ? 'right' : 'left'}
                                        >
                                            <div
                                                className={classNames(
                                                    styles.menuBarItem,
                                                    styles.hoverable,
                                                    styles.accountNavMenu
                                                )}
                                            >
                                                <img
                                                    className={styles.profileIcon}
                                                    src={profileIcon}
                                                />
                                                <span>
                                                    {'scratch-cat'}
                                                </span>
                                                <img
                                                    className={styles.dropdownCaretIcon}
                                                    src={dropdownCaret}
                                                />
                                            </div>
                                        </MenuBarItemTooltip>
                                    </React.Fragment>
                                ) : []}
                            </React.Fragment>
                        )} */}
                    </div>

                    {aboutButton}

                    
                </Box>
                
            </>
        );
    }
}

MenuBar.propTypes = {
    aboutMenuOpen: PropTypes.bool,
    accountMenuOpen: PropTypes.bool,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    autoUpdateProject: PropTypes.func,
    // canChangeLanguage: PropTypes.bool,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canManageFiles: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canShare: PropTypes.bool,
    className: PropTypes.string,
    confirmReadyToReplaceProject: PropTypes.func,
    editMenuOpen: PropTypes.bool,
    backPackMenuOpen: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    fileMenuOpen: PropTypes.bool,
    intl: intlShape,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    isUpdating: PropTypes.bool,
    // languageMenuOpen: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    loginMenuOpen: PropTypes.bool,
    logo: PropTypes.string,
    modeMenuOpen: PropTypes.bool,
    modeNow: PropTypes.bool,
    mode220022BC: PropTypes.bool,
    mode1920: PropTypes.bool,
    mode1990: PropTypes.bool,
    mode2020: PropTypes.bool,

    onClickAbout: PropTypes.oneOfType([
        PropTypes.func, // button mode: call this callback when the About button is clicked
        PropTypes.arrayOf( // menu mode: list of items in the About menu
            PropTypes.shape({
                title: PropTypes.string, // text for the menu item
                onClick: PropTypes.func // call this callback when the menu item is clicked
            })
        )
    ]),
    onClickAccount: PropTypes.func,
    onSetTimeTravelMode: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickFile: PropTypes.func,
    // onClickLanguage: PropTypes.func,
    onClickLogin: PropTypes.func,
    onClickLogo: PropTypes.func,
    onClickMode: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickRemix: PropTypes.func,
    onClickSave: PropTypes.func,
    onClickSaveAsCopy: PropTypes.func,
    onLogOut: PropTypes.func,
    onSubmitProject: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onOpenTipLibrary: PropTypes.func,
    onProjectTelemetryEvent: PropTypes.func,
    onRequestOpenAbout: PropTypes.func,
    onRequestCloseAbout: PropTypes.func,
    onRequestCloseAccount: PropTypes.func,
    onRequestCloseEdit: PropTypes.func,
    onRequestCloseFile: PropTypes.func,
    // onRequestCloseLanguage: PropTypes.func,
    onRequestCloseLogin: PropTypes.func,
    onRequestCloseMode: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    onStartSelectingFileUpload: PropTypes.func,
    onStartSelectingBackPackFile: PropTypes.func,
    onStartSaveBackPackFile: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    projectTitle: PropTypes.string,
    renderLogin: PropTypes.func,
    sessionExists: PropTypes.bool,
    shouldSaveBeforeTransition: PropTypes.func,
    showComingSoon: PropTypes.bool,
    userOwnsProject: PropTypes.bool,
    username: PropTypes.string,
    vm: PropTypes.instanceOf(VM).isRequired
};

MenuBar.defaultProps = {
    logo: scratchLogo,
    stemAcademyLogo: stemAcademyLogo,
    onShare: () => {}
};

let getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const user = state.session && state.session.session && state.session.session.user;

    // state.scratchGui.projectTitle = decodeURIComponent( getCookie( "stemground_project_name" ) ) || "test project name";
    // state.locales.locale = "zh-cn";
    return {
        aboutMenuOpen: aboutMenuOpen(state),
        accountMenuOpen: accountMenuOpen(state),
        fileMenuOpen: fileMenuOpen(state),
        editMenuOpen: editMenuOpen(state),
        backPackMenuOpen: backPackMenuOpen(state),
        isRtl: state.locales.isRtl,
        isUpdating: getIsUpdating(loadingState),
        isShowingProject: getIsShowingProject(loadingState),
        // languageMenuOpen: languageMenuOpen(state),
        locale: state.locales.locale,
        loginMenuOpen: loginMenuOpen(state),
        modeMenuOpen: modeMenuOpen(state),
        // projectTitle: state.scratchGui.projectTitle,
        projectTitle: state.scratchGui.projectTitle,
        sessionExists: state.session && typeof state.session.session !== 'undefined',
        username: user ? user.username : null,
        userOwnsProject: ownProps.authorUsername && user &&
            (ownProps.authorUsername === user.username),
        vm: state.scratchGui.vm,
        mode220022BC: isTimeTravel220022BC(state),
        mode1920: isTimeTravel1920(state),
        mode1990: isTimeTravel1990(state),
        mode2020: isTimeTravel2020(state),
        modeNow: isTimeTravelNow(state)
    };
};


const mapDispatchToProps = dispatch => ({
    autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenTipLibrary: () => dispatch(openTipsLibrary()),
    onClickAccount: () => dispatch(openAccountMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onClickFile: () => dispatch(openFileMenu()),
    onRequestCloseFile: () => dispatch(closeFileMenu()),
    onClickEdit: () => dispatch(openEditMenu()),
    onRequestCloseEdit: () => dispatch(closeEditMenu()),
    // onClickLanguage: () => dispatch(openLanguageMenu()),
    // onRequestCloseLanguage: () => dispatch(closeLanguageMenu()),
    onClickLogin: () => dispatch(openLoginMenu()),
    onRequestCloseLogin: () => dispatch(closeLoginMenu()),
    onClickMode: () => dispatch(openModeMenu()),
    onRequestCloseMode: () => dispatch(closeModeMenu()),
    onRequestOpenAbout: () => dispatch(openAboutMenu()),
    onRequestCloseAbout: () => dispatch(closeAboutMenu()),
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
    onClickRemix: () => dispatch(remixProject()),
    onClickSave: () => dispatch(manualUpdateProject()),
    onClickSaveAsCopy: () => dispatch(saveProjectAsCopy()),
    onSeeCommunity: () => dispatch(setPlayer(true)),
    onSetTimeTravelMode: mode => dispatch(setTimeTravel(mode)),
    onClickBackPack: () => dispatch(openBackPackMenu()),
    onRequestCloseBackPack: () => dispatch(closeBackPackMenu())

});

export default compose(
    injectIntl,
    MenuBarHOC,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(MenuBar);
